import { Modal } from "react-bootstrap";
import {
  popCancelBttn,
  imsLoader
} from "../../assets";
import { v4 as uuidv4 } from "uuid";
import { Component } from "react";
import Button from "../Button";
import "../PopUp/GlobalSearchFeaturesPopUp.css";
import "./GenAICommonPopUp.css";
import SuccessReadingList from "../PopUp/SucessReadingList";
import SucessCommonPopup from "./SucessCommonPopup";
import ApiServices from "../../utils/apiServices";
import RenameNotebookPopup from "../PopUp/RenameNotebookPopup";
import GenAIRenameNotebookPopup from "./GenAIRenameNotebookPopup";
import { snippetLongString } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import { getVarType } from "../GenerateArrayStrings";
import trackingService from "../../services/trackingService";
import moment from 'moment';
import { isEmptyObject } from "jquery";
import { LocationOrigin } from "../../utils/utilityServices";
import axios from "axios";
import { Authentication } from "../../utils/authenticationUtilityServices";
class GenAINotebookListPopUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPop: false,
      isPin: true,
      isManage: false,
      apiResponse: [],
      notebookListName: "",
      notebookListID: "",
      docID: "",
      isLoaded: false,
      showSuccess: false,
      selectedNotebookLists: [],
      showRenamePop: false,
      itemtoBeRenamedName: "",
      itemtoBeRenamedID: "",
      successMessage: "",
      error: "",
      nodeName: "",
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      isInsertSuccess: false,
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageId: -1,
    };
  }
  async componentDidMount() {
    let wwid = JSON.parse(localStorage.getItem("wwid"));
    let service = new ApiServices();
    this.setState({
      showPop: this.props.showModal,
      docID: this.props.docID,
    });
    let apiRes = await service.getNotebookLists(wwid);
    //console.log(apiRes);
    this.setState(
      {
        apiResponse: apiRes,
        isLoaded: true,
      }
    );
    if (this.props.isFromGlobalFeaturesMenu) {
      this.setState({
        isPin: false,
        isManage: true,
      })
    }
  }

  showConfirmMessage = (message, id) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageId: id
    })
  }

  confirmHandler = async () => {
    const { confirmMessageId } = this.state;
    let username = JSON.parse(localStorage.getItem('username'))
    let wwid = JSON.parse(localStorage.getItem("wwid"));
    if (username) {
      username = username.toLowerCase();
    }
    let service = new ApiServices();

    await service.deleteNotebookLists(confirmMessageId, wwid);
    this.setState(
      {
        isLoaded: false,
        confirmMessageContent: "",
        confirmMessageShowModal: false,
        confirmMessageId: -1
      },
      async () => {
        let { selectedNotebookLists } = this.state
        let apiRes = await service.getNotebookLists(wwid);
        let notebookIds = apiRes.map(x => x.notebooklist_id);
        selectedNotebookLists = selectedNotebookLists.filter(x => notebookIds.includes(x.notebooklist_id));
        this.setState({
          apiResponse: apiRes,
          isLoaded: true,
          selectedNotebookLists: selectedNotebookLists
        });
      }
    );
  }


  closeConfirmMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false
    })
  }

  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      notebookListName: e.target.value,
    });
  };
  handleCheckBox = (e, itemCounts) => {

    let arr = this.state.selectedNotebookLists;
    if (e.target.checked) {
      arr.push(e.target.value);
    } else {
      var idx = arr.indexOf(e.target.value);
      if (idx !== -1) {
        arr.splice(idx, 1);
      }
    }
    this.setState({
      selectedNotebookLists: arr,
    });
  };
  URLConstructor = (item, shareOption) => {
    let url
    let docTitle = encodeURIComponent(item.docTitle)
    let { orderedBy, orderedFor } = item;
    if (!orderedBy) orderedBy = '';
    if (!orderedFor) orderedFor = '';
    if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
      url = `/DocURL?ID=${item.docID}&ref=${shareOption}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      // url = `/DocURL?ID=${docTitle}&ref=${shareOption}&cs=${item.domain}`
    }
    else if (item.domain === 'SKM' || item.domain === "MIAs" || item.domain === "MIAsReferences") {
      url = `/DocURL?ID=${item.docID}&ref=${shareOption}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
    }
    else {
      url = `/DocURL?ID=${item.docID}&ref=${shareOption}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
        url = url + `&docState=anr`
      }
    }
    if (item.enclosureDocID) {
      url += `&enclosureID=${item.enclosureDocID}`
    }

    return url
  }
  indexDataOnAMA = (orignalCitation, AMACitation, sessionid, requestTokenCount, responseTokenCount, item) => {
    let authoringinfo = {
      "orignalCitation": orignalCitation,
      "AMACitation": AMACitation,
      "sessionid": sessionid,
      "requestTokenCount": requestTokenCount,
      "responseTokenCount": responseTokenCount
    }
    const ts = new trackingService();
    let { orderedBy, orderedFor } = item;
    if (!orderedBy) orderedBy = '';
    if (!orderedFor) orderedFor = '';
    let docVersion = '', docNumber = ''
    if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
      docVersion = item.r_version_label;
      docNumber = item.jj_number;
    }
    else if (item.domain === 'SKM') {
      docNumber = item.domain;
    }
    else if (item.domain === 'CTGov') {
      docNumber = item.docID;
    }
    else {
      docVersion = item.majorVersionNumber;
      docNumber = item.documentNumber;
    }
    let url = '';
    if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
    }
    else if (item.domain === 'SKM' || item.domain === "MIAs") {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
    }
    else {
      url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
        url = url + `&docState=anr`
      }
    }
    if (item.enclosureDocID) {
      url += `&enclosureID=${item.enclosureDocID}`
    }
    let newUrl = window.origin + url;

    ts.indexTrackingData(localStorage.getItem('userdisplayName'),
      localStorage.getItem('wwid'),
      localStorage.getItem('username'),
      localStorage.getItem('function'),
      localStorage.getItem('region'),
      localStorage.getItem('userproducts'),
      localStorage.getItem('doctypepref'),
      localStorage.getItem('sid'),
      localStorage.getItem('deviceType'),
      localStorage.getItem('deviceOS'),
      localStorage.getItem('browserName'),
      localStorage.getItem('browserVersion'),
      localStorage.getItem('jnjDepartment'),
      localStorage.getItem('companyname'),
      `Conducted AMACitation`,
      '',
      window.location.href, '', '', item.docTitle, docVersion, docNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, 'Conducted AMACitation', '', '', item.domain, '', '', item.createdDate, orderedBy, orderedFor,
      {}, authoringinfo);
  }
  indexData = (orignaltext, summarizetext, commandtype, notebooklistId, notebooklistName, referencetext, notesText, tableSummarizedHtml, item) => {
    if (!isEmptyObject(item)) {
      let { orderedBy, orderedFor } = item;
      if (!orderedBy) orderedBy = '';
      if (!orderedFor) orderedFor = '';
      let docVersion = '', docNumber = ''
      if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
        docVersion = item.r_version_label;
        docNumber = item.jj_number;
      }
      else if (item.domain === 'SKM') {
        docNumber = item.domain;
      }
      else if (item.domain === 'CTGov') {
        docNumber = item.docID;
      }
      else {
        docVersion = item.majorVersionNumber;
        docNumber = item.documentNumber;
      }
      let url = '';
      if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
        url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      }
      else if (item.domain === 'SKM' || item.domain === "MIAs") {
        url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
      }
      else {
        url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
          url = url + `&docState=anr`
        }
      }
      if (item.enclosureDocID) {
        url += `&enclosureID=${item.enclosureDocID}`
      }
      let newUrl = window.origin + url;
      let authoringinfo = {
        "orignaltext": orignaltext,
        "summarizetext": summarizetext,
        "commandtype": commandtype,
        "notebooklistId": notebooklistId,
        "notebooklistName": notebooklistName,
        "referencetext": referencetext,
        "notesText": notesText,
        "tableSummarizedHtml": tableSummarizedHtml
      }
      const ts = new trackingService();
      ts.indexTrackingData(localStorage.getItem('userdisplayName'),
        localStorage.getItem('wwid'),
        localStorage.getItem('username'),
        localStorage.getItem('function'),
        localStorage.getItem('region'),
        localStorage.getItem('userproducts'),
        localStorage.getItem('doctypepref'),
        localStorage.getItem('sid'),
        localStorage.getItem('deviceType'),
        localStorage.getItem('deviceOS'),
        localStorage.getItem('browserName'),
        localStorage.getItem('browserVersion'),
        localStorage.getItem('jnjDepartment'),
        localStorage.getItem('companyname'),
        `Save Notebook`,
        '',
        window.location.href, '', '', item.docTitle, docVersion, docNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, 'Save Notebook', '', '', item.domain, '', '', item.createdDate, orderedBy, orderedFor,
        {}, authoringinfo);
    } else {
      let authoringinfo = {
        "orignaltext": orignaltext,
        "summarizetext": summarizetext,
        "commandtype": commandtype,
        "notebooklistId": notebooklistId,
        "notebooklistName": notebooklistName,
        "referencetext": referencetext,
        "notesText": notesText,
        "tableSummarizedHtml": tableSummarizedHtml
      }
      const ts = new trackingService();
      ts.indexTrackingData(localStorage.getItem('userdisplayName'),
        localStorage.getItem('wwid'),
        localStorage.getItem('username'),
        localStorage.getItem('function'),
        localStorage.getItem('region'),
        localStorage.getItem('userproducts'),
        localStorage.getItem('doctypepref'),
        localStorage.getItem('sid'),
        localStorage.getItem('deviceType'),
        localStorage.getItem('deviceOS'),
        localStorage.getItem('browserName'),
        localStorage.getItem('browserVersion'),
        localStorage.getItem('jnjDepartment'),
        localStorage.getItem('companyname'),
        `Save Notebook`,
        '',
        window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
        {}, authoringinfo);
    }

  }
  convertCitationToAMA = async (referencetext, item) => {
    let { sessionID } = this.props;
    let referenceAMA = "";
    var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
    if (window.location.origin === 'https://predev-ims.jnj.com') {
      url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
    }
    //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_AMA}ama_api2`
    this.setState({ isLoaded: false })
    const _headers = {
      'Content-Type': 'application/json'
    }
    if (await Authentication.isAccessTokenAvailable()) {
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    let config = {
      method: 'POST',
      url: url,
      headers: _headers,
      data: {
        "orignalCitation": referencetext,
        "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
        "sessionID": sessionID,
        "wwid": JSON.parse(localStorage.getItem('wwid')),
      }
    }
    await axios(config).then((response) => {
      if (response.data.AMACitation) {
        referenceAMA = response.data.AMACitation;
        let requestTokenCount = 0, responseTokenCount = 0;
        if (response.data.requestTokenCount)
          requestTokenCount = response.data.requestTokenCount;
        if (response.data.responseTokenCount)
          responseTokenCount = response.data.responseTokenCount;

        this.indexDataOnAMA(referencetext, response.data.AMACitation, sessionID, requestTokenCount, responseTokenCount, item);
      }

    }).catch((error) => {
      console.log(error)
      referenceAMA = referencetext;
    });
    return referenceAMA;
  }
  onclickProceed = async () => {
    // let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let wwid = JSON.parse(localStorage.getItem("wwid"));

    let service = new ApiServices();
    if (this.handleValidation()) {
      let referencetexts = [], referencetext = '', _notesText = '';
      let { notesText, citationText } = this.props
      if (citationText) {
        referencetext = citationText;
      } else {
        let { docTitle, authors, literatureSource } = this.props.sourceItem;
        let strAuthors = (authors && authors.length > 0) ? getVarType(authors) === 'Array' ? authors.join(", ") : authors : "";
        if (strAuthors) {
          referencetexts.push(`${strAuthors}`)
        }
        if (docTitle) {
          referencetexts.push(`${docTitle}`)
        }
        if (literatureSource) {
          referencetexts.push(`${literatureSource}`)
        }
        referencetext = referencetexts.join('. ');
        referencetext = await this.convertCitationToAMA(referencetext, this.props.sourceItem);
      }
      if (notesText) {
        _notesText = notesText;
      }
      let { sourceItem } = this.props;
      let _url = '', _docTitle = ''
      if (this.props.sourceItem && !isEmptyObject(this.props.sourceItem)) {
        _url = this.URLConstructor(this.props.sourceItem, 'notebook')
        _docTitle = this.props.sourceItem.docTitle
      }
      let { summeryText, summarizeText, commandType, commandText } = this.props;
      if (this.state.notebookListName !== "") {
        let listID = uuidv4();
        let _summeryText = summeryText.split(' ').filter((x, i) => i < 2000).join(' ')
        let _summarizeText = commandType !== 'CreateTable' ? summarizeText : '';
        let _tableSummarizedHtml = commandType === 'CreateTable' ? summarizeText : '';
        await service.insertUpdateNotebookList(
          wwid,
          `NL_${listID}`,
          this.state.notebookListName,
          _summeryText,
          _summarizeText,
          referencetext,
          _notesText,
          _tableSummarizedHtml,
          commandType,
          commandText,
          _docTitle,
          _url,
        );

        this.indexData(_summeryText, _summarizeText, commandType, `NL_${listID}`, this.state.notebookListName, referencetext, _notesText, _tableSummarizedHtml, sourceItem);
        //console.log("ID:"+`RL_${listID}`+" Name:"+this.state.notebookListName+" Doc ID:"+this.state.docID)
        this.setState({
          successMessage:
            "The note was saved successfully to new Notebook.",
        });
      }
      if (this.state.selectedNotebookLists.length > 0) {
        for (const itr of this.state.selectedNotebookLists) {
          let nlName = this.state.apiResponse.find(
            (e) => e.notebooklist_id === itr
          );
          let _summarizeText = commandType !== 'CreateTable' ? summarizeText : '';
          let _tableSummarizedHtml = commandType === 'CreateTable' ? summarizeText : '';
          let _summeryText = summeryText.split(' ').filter((x, i) => i < 2000).join(' ')
          await service.insertUpdateNotebookList(
            wwid,
            itr,
            nlName.notebooklist_name,
            _summeryText,
            _summarizeText,
            referencetext,
            _notesText,
            _tableSummarizedHtml,
            commandType,
            commandText,
            _docTitle,
            _url,
          );
          this.indexData(_summeryText, _summarizeText, commandType, itr, nlName.notebooklist_name, referencetext, _notesText, _tableSummarizedHtml, sourceItem);
        }
        this.setState({
          successMessage:
            "The note was saved successfully to selected existing Notebook(s).",
        });
      }
      if (
        this.state.notebookListName !== "" &&
        this.state.selectedNotebookLists.length > 0
      ) {
        this.setState({
          successMessage:
            "The note was saved successfully to selected existing new Notebook(s) and the new Notebook.",
        });
      }
      this.setState({
        isLoaded: true,
        showSuccess: true,
        isInsertSuccess: true
      });
    }
  };
  handleOnClickView = async (nID, nName) => {
    let url = `/notebookView?notebookName=${encodeURIComponent(nName)}&notebookId=${nID}`;
    window.open(url, "_blank");
  };
  handleRename = (id, name) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
    });
  };
  handleRenameClose = (status) => {
    this.setState(
      {
        showRenamePop: status,
        isLoaded: false,
      },
      async () => {
        // let username = JSON.parse(
        //   localStorage.getItem("username")
        // ).toLowerCase();
        let wwid = JSON.parse(localStorage.getItem("wwid"));
        let service = new ApiServices();
        let apiRes = await service.getNotebookLists(wwid);
        this.setState({
          apiResponse: apiRes,
          isLoaded: true,
        });
      }
    );
  };
  handleRemove = async (id) => {
    this.showConfirmMessage("Are you sure you want to delete this notebook?", id)
  };
  handleSuccessClose = (status) => {
    this.setState({
      showSuccess: status,
      //showPop: false,
      isManage: true,
      isPin: false,
      isLoaded: false
    },
      async () => {
        // let username = JSON.parse(
        //   localStorage.getItem("username")
        // ).toLowerCase();
        let wwid = JSON.parse(localStorage.getItem("wwid"));
        let service = new ApiServices();
        let apiRes = await service.getNotebookLists(wwid);
        this.setState(
          {
            apiResponse: apiRes,
            isLoaded: true
          }
        );
      });
    //this.props.handleClose(false);
  };
  handleOnFocusInput = (e) => {
    this.setState({ nodeName: e.target.nodeName });
  };
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let notebookList = this.state.apiResponse.map((data) =>
      data.notebooklist_name.toLowerCase()
    );
    if (
      this.state.notebookListName.length <= 0 &&
      this.state.selectedNotebookLists.length <= 0 &&
      this.state.nodeName !== "INPUT"
    ) {
      formIsValid = false;
      this.errorAlertMessage("Please enter either New Notebook name or select any Existing Notebook to proceed.")
      // errors["pinNotebookList"] = 'Please enter a valid name to proceed.';
    }
    if (
      this.state.notebookListName.length <= 0 &&
      this.state.nodeName === "INPUT" &&
      this.state.selectedNotebookLists.length <= 0
    ) {
      formIsValid = false;
      errors["pinNotebookList"] = `Please enter a valid name to proceed.`;
    }
    if (notebookList.includes(this.state.notebookListName.toLowerCase())) {
      formIsValid = false;
      errors[
        "pinNotebookList"
      ] = `You already have a notebook with entered title. Please enter a new title.`;
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  render() {
    const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, } = this.state;
    const { confirmMessageContent, confirmMessageShowModal } = this.state;
    let isInsertSuccess = this.state.isInsertSuccess || this.props.isFromGlobalFeaturesMenu;
    if (this.props.width <= 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-authoring"
            backdropClassName="z-index-authoring-backdrop"
            scrollable={true}
          >
            <div style={{ borderTop: `5px solid #EB1700` }}>
              {/* <div className="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={e => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                />
              </div> */}
              <div>
                <Modal.Header
                  className="gsfModalHeader"
                  style={{ justifyContent: "left", padding: "0.5rem 0" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "100%",
                      paddingTop: "1%",
                    }}
                  >
                    <Modal.Title>
                      <div className="actionItem-headerPart">
                        {!isInsertSuccess && (
                          <div
                            onClick={(e) => {
                              this.setState({ isPin: true, isManage: false });
                            }}
                            className={
                              this.state.isPin
                                ? "active-pin-features-button"
                                : "pin-features-buttons"
                            }
                            style={{ margin: "1% 0" }}
                          >
                            <span>Create Notebook</span>
                          </div>
                        )}
                        {/* <div className="action-button-saperation-line"></div> */}
                        <div
                          onClick={(e) => {
                            this.setState({ isPin: false, isManage: true });
                          }}
                          className={
                            this.state.isManage
                              ? "active-pin-features-button"
                              : "pin-features-buttons"
                          }
                          style={{ margin: "1% 0" }}
                        >
                          <span>View/Manage Notebooks</span>
                        </div>
                      </div>
                    </Modal.Title>
                  </div>
                </Modal.Header>
                <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                  {this.state.isPin && (
                    <div>
                      {this.state.isLoaded ? (
                        <>
                          <span style={{ color: "black" }}>
                            My Notebooks
                          </span>{" "}
                          :
                          {this.state.apiResponse.length > 0 ? (
                            <span>
                              <ul className="reading-list-wrapper">
                                {this.state.apiResponse.map((item) => {
                                  return (
                                    <li key={item.notebooklist_id}>
                                      <span>
                                        <input
                                          type="checkbox"
                                          value={item.notebooklist_id}
                                          className="reading-list-checkbox-wrapper"
                                          onChange={e => this.handleCheckBox(e, item.docCount)}
                                        />
                                      </span>
                                      {item.notebooklist_name}
                                    </li>
                                  );
                                })}
                              </ul>
                            </span>
                          ) : (
                            <span>
                              You currently do not have any notebooks created.
                              <br />
                            </span>
                          )}
                          <br />
                          <div>
                            Create A New Notebook By Entering A Title Below:
                          </div>
                          <br />
                          <input
                            type="text"
                            placeholder="Type here"
                            value={this.state.notebookListName}
                            className="reading-list-input-box"
                            onChange={this.handleInput}
                            onFocus={this.handleOnFocusInput}
                          />
                          <br />
                          <span className="length-info">Name with a maximum of 100 characters.</span>
                          <div className="errorInvalidName">
                            {this.state.error["pinNotebookList"]}
                          </div>
                          <br />
                        </>
                      ) : (
                        <div style={{ textAlign: "center", padding: "10%" }}>
                          <img
                            src={imsLoader}
                            alt="Loading Data"
                            style={{ width: "10%" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isManage && (
                    <div>
                      {this.state.isLoaded ? (
                        <>
                          {this.state.apiResponse.length > 0 ? (
                            <span>
                              <table className="reading-list-view-wrapper">
                                <tr>
                                  <th style={{ color: "#333" }}>
                                    Notebook Name
                                  </th>
                                  <th
                                    style={{ textAlign: "center", color: "#333" }}
                                  >
                                    Actions
                                  </th>
                                </tr>
                                <tbody>
                                  {this.state.apiResponse.map((item) => {
                                    return (
                                      <tr key={item.notebooklist_id}>
                                        <td>{item.notebooklist_name}</td>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            width: "100%",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <span
                                            onClick={(e) =>
                                              this.handleOnClickView(
                                                item.notebooklist_id,
                                                item.notebooklist_name
                                              )
                                            }
                                            title="View"
                                            className="reading-list-action-text"
                                          >
                                            View
                                          </span>
                                          <span
                                            onClick={(e) =>
                                              this.handleRename(
                                                item.notebooklist_id,
                                                item.notebooklist_name
                                              )
                                            }
                                            title="Rename"
                                            className="reading-list-action-text"
                                          >
                                            Rename
                                          </span>
                                          <span
                                            title="Remove"
                                            className="reading-list-action-text"
                                            onClick={(e) =>
                                              this.handleRemove(
                                                item.notebooklist_id
                                              )
                                            }
                                          >
                                            Remove
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </span>
                          ) : (
                            <span>
                              {" "}
                              You currently do not have any notebooks created.
                            </span>
                          )}
                        </>
                      ) : (
                        <div style={{ textAlign: "center", padding: "10%" }}>
                          <img
                            src={imsLoader}
                            alt="Loading Data"
                            style={{ width: "10%" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </Modal.Body>
                {this.state.isPin ? (
                  <div className="pin-popup-button-wrapper">
                    {/* <div style={{margin:"1% 0"}}> */}
                    <button
                      className="pin-pop-up-button-cancel"
                      onClick={(e) => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}
                    >
                      Cancel
                    </button>
                    {/* <Button text="Cancel" customColor="#000000" action={() => { this.setState({ showPop: false });this.props.handleClose(false); }} /> */}
                    {/* </div>
                    <div style={{margin:"1% 0"}}> */}
                    <button
                      className="pin-pop-up-button-proceed"
                      onClick={(e) => {
                        this.onclickProceed();
                      }}
                    >
                      Save Notebook
                    </button>
                    {/* <Button text="Pin" customColor="#EB1700" action={this.onclickProceed} /> */}
                    {/* </div> */}
                  </div>
                ) : (
                  <div className="pin-popup-button-wrapper">
                    <Button
                      text="Cancel"
                      customColor="#000000"
                      action={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            {this.state.showSuccess && (
              <>
                <SuccessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenameNotebookPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  nName={this.state.itemtoBeRenamedName}
                  nID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    } else if (this.props.width > 600 && this.props.width <= 1000) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-authoring"
            backdropClassName="z-index-authoring-backdrop"
            scrollable={true}
          >
            <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
              {/* <div className="popup-cancel-btn-wrapper">
                   <img
                     src={popCancelBttn}
                     alt=""
                     onClick={e => {
                       this.setState({ showPop: false });
                       this.props.handleClose(false);
                     }}
                   />
                 </div> */}
              <div>
                <Modal.Header
                  className="gsfModalHeader"
                  style={{ justifyContent: "left", padding: "0.5rem 0" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "100%",
                      paddingTop: "1%",
                    }}
                  >
                    <Modal.Title>
                      <div className="actionItem-headerPart">
                        {!isInsertSuccess && (<>
                          <div
                            onClick={(e) => {
                              this.setState({ isPin: true, isManage: false });
                            }}
                            className={
                              this.state.isPin
                                ? "active-pin-features-button"
                                : "pin-features-buttons"
                            }
                            style={{ margin: "1% 0" }}
                          >
                            <span>Create Notebook</span>
                          </div>
                          <div className="action-button-saperation-line"></div>
                        </>
                        )}
                        <div
                          onClick={(e) => {
                            this.setState({ isPin: false, isManage: true });
                          }}
                          className={
                            this.state.isManage
                              ? "active-pin-features-button"
                              : "pin-features-buttons"
                          }
                          style={{ margin: "1% 0" }}
                        >
                          <span>View/Manage Notebooks</span>
                        </div>
                      </div>
                    </Modal.Title>
                  </div>
                </Modal.Header>
                <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                  {this.state.isPin && (
                    <div>
                      {this.state.isLoaded ? (
                        <>
                          <span style={{ color: "black" }}>
                            My Notebooks
                          </span>{" "}
                          :
                          {this.state.apiResponse.length > 0 ? (
                            <span>
                              <ul className="reading-list-wrapper">
                                {this.state.apiResponse.map((item) => {
                                  return (
                                    <li key={item.notebooklist_id}>
                                      <span>
                                        <input
                                          type="checkbox"
                                          value={item.notebooklist_id}
                                          className="reading-list-checkbox-wrapper"
                                          onChange={e => this.handleCheckBox(e, item.docCount)}
                                        />
                                      </span>
                                      {item.notebooklist_name}
                                    </li>
                                  );
                                })}
                              </ul>
                            </span>
                          ) : (
                            <span>
                              You currently do not have any notebooks created.
                              <br />
                            </span>
                          )}
                          <br />
                          <div>
                            Create A New Notebook By Entering A Title Below:
                          </div>
                          <br />
                          <input
                            type="text"
                            placeholder="Type here"
                            value={this.state.notebookListName}
                            className="reading-list-input-box"
                            onChange={this.handleInput}
                            onFocus={this.handleOnFocusInput}
                          />
                          <br />
                          <span className="length-info">Name with a maximum of 100 characters.</span>
                          <div className="errorInvalidName">
                            {this.state.error["pinNotebookList"]}
                          </div>
                          <br />
                        </>
                      ) : (
                        <div style={{ textAlign: "center", padding: "10%" }}>
                          <img
                            src={imsLoader}
                            alt="Loading Data"
                            style={{ width: "10%" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  {this.state.isManage && (
                    <div>
                      {this.state.isLoaded ? (
                        <>
                          {this.state.apiResponse.length > 0 ? (
                            <span>
                              <table className="reading-list-view-wrapper">
                                <tr>
                                  <th>Notebook Name</th>
                                  <th style={{ textAlign: "center" }}>Date</th>
                                  <th style={{ textAlign: "center" }}>Actions</th>
                                </tr>
                                <tbody>
                                  {this.state.apiResponse.map((item) => {
                                    return (
                                      <tr key={item.notebooklist_id}>
                                        <td>{item.notebooklist_name}</td>
                                        <td style={{ textAlign: "center" }}>
                                          {moment(item.added_on).format("D-MMM-YYYY")}
                                        </td>
                                        <td
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            width: "100%",
                                          }}
                                        >
                                          <span
                                            onClick={(e) =>
                                              this.handleOnClickView(
                                                item.notebooklist_id,
                                                item.notebooklist_name
                                              )
                                            }
                                            title="View"
                                            className="reading-list-action-text"
                                          >
                                            View
                                          </span>
                                          <span className="action-items-separate-divider"></span>
                                          <span
                                            onClick={(e) =>
                                              this.handleRename(
                                                item.notebooklist_id,
                                                item.notebooklist_name
                                              )
                                            }
                                            title="Rename"
                                            className="reading-list-action-text"
                                          >
                                            Rename
                                          </span>
                                          <span className="action-items-separate-divider"></span>
                                          <span
                                            title="Remove"
                                            className="reading-list-action-text"
                                            onClick={(e) =>
                                              this.handleRemove(
                                                item.notebooklist_id
                                              )
                                            }
                                          >
                                            Remove
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </span>
                          ) : (
                            <span>
                              {" "}
                              You currently do not have any notebooks created.
                            </span>
                          )}
                        </>
                      ) : (
                        <div style={{ textAlign: "center", padding: "10%" }}>
                          <img
                            src={imsLoader}
                            alt="Loading Data"
                            style={{ width: "10%" }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </Modal.Body>
                {this.state.isPin ? (
                  <div
                    className="gsf-popup-button-wrapper"
                    style={{ width: "40%" }}
                  >
                    <Button
                      text="Cancel"
                      customColor="#000000"
                      action={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}
                    />
                    <Button
                      text="Save Notebook"
                      customColor="#EB1700"
                      action={this.onclickProceed}
                    />
                  </div>
                ) : (
                  <div className="reading-list-button-tablet-wrapper">
                    <Button
                      text="Cancel"
                      customColor="#000000"
                      action={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            {this.state.showSuccess && (
              <>
                <SuccessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenameNotebookPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  nName={this.state.itemtoBeRenamedName}
                  nID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    } else {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            className="z-index-authoring"
            backdropClassName="z-index-authoring-backdrop"
            scrollable={true}
          >
            <div className="gen-ai-common-popup">
              <div className="gen-ai-common-popup__top-row">
                <div className="gen-ai-common-popup__tabs">
                  {!isInsertSuccess && (
                    <button
                      onClick={(e) => {
                        this.setState({ isPin: true, isManage: false });
                      }}
                      className={`gen-ai-common-popup__tab ${this.state.isPin ? "gen-ai-common-popup__tab--active" : ""}`}>
                      Create Notebook</button>
                  )}
                  <button onClick={(e) => {
                    this.setState({ isPin: false, isManage: true });
                  }}
                    className={`gen-ai-common-popup__tab ${this.state.isManage ? "gen-ai-common-popup__tab--active" : ""}`}>
                    View/Manage Notebooks</button>
                </div>
                <div className="gen-ai-common-popup__icon-area" onClick={e => {
                  this.setState({ showPop: false });
                  this.props.handleClose(false);
                }} aria-hidden="true">
                  <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <div className="gen-ai-common-popup__body">
                {this.state.isPin && (
                  <div>
                    {this.state.isLoaded ? (
                      <>
                        <span style={{ color: "black" }}>
                          My Notebooks
                        </span>{" "}
                        :
                        {this.state.apiResponse.length > 0 ? (
                          <span>
                            <ul className="reading-list-wrapper">
                              {this.state.apiResponse.map((item) => {
                                return (
                                  <li key={item.notebooklist_id}>
                                    <span>
                                      <input
                                        type="checkbox"
                                        value={item.notebooklist_id}
                                        className="reading-list-checkbox-wrapper"
                                        onChange={e => this.handleCheckBox(e, item.docCount)}
                                      />
                                    </span>
                                    {item.notebooklist_name}
                                  </li>
                                );
                              })}
                            </ul>
                          </span>
                        ) : (
                          <span>
                            You currently do not have any notebooks created.
                            <br />
                          </span>
                        )}
                        <br />
                        <div>
                          Create A New Notebook By Entering A Title Below:
                        </div>
                        <br />
                        <input
                          type="text"
                          placeholder="Type here"
                          value={this.state.notebookListName}
                          className="reading-list-input-box"
                          onChange={this.handleInput}
                          onFocus={this.handleOnFocusInput}
                        />
                        <br />
                        <span className="length-info">Name with a maximum of 100 characters.</span>
                        <div className="errorInvalidName">
                          {this.state.error["pinNotebookList"]}
                        </div>
                        <br />
                      </>
                    ) : (
                      <div style={{ textAlign: "center", padding: "10%" }}>
                        <img
                          src={imsLoader}
                          alt="Loading Data"
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {this.state.isManage && (
                  <div>
                    {this.state.isLoaded ? (
                      <>
                        {this.state.apiResponse.length > 0 ? (
                          <div className="gen-ai-common-popup__inner">
                            <div className="gen-ai-common-popup__header-row" role="row">
                              <div className="gen-ai-common-popup__header gen-ai-common-popup__header--name">Notebook Name</div>
                              <div className="gen-ai-common-popup__header gen-ai-common-popup__header--date">Date Saved</div>
                              <div className="gen-ai-common-popup__header gen-ai-common-popup__header--actions" aria-hidden>
                                Actions
                              </div>
                            </div>
                            <ul className="gen-ai-common-popup__list" role="list">
                              {this.state.apiResponse.map((item, index) => (
                                <li className="gen-ai-common-popup__row" key={item.notebooklist_id} role="listitem">
                                  <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--name">
                                    <span className="gen-ai-common-popup__link-name">{item.notebooklist_name}</span>
                                  </div>
                                  <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--date">
                                    <span className="gen-ai-common-popup__date">{moment(item.added_on).format("D-MMM-YYYY")}</span>
                                  </div>

                                  <div className="gen-ai-common-popup__cell gen-ai-common-popup__cell--actions">
                                    <div className="gen-ai-common-popup__actions">
                                      <button
                                        type="button"
                                        className="gen-ai-common-popup__icon-btn"
                                        title="View"
                                        onClick={(e) =>
                                          this.handleOnClickView(
                                            item.notebooklist_id,
                                            item.notebooklist_name
                                          )
                                        }>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g clip-path="url(#clip0_1683_4216)">
                                            <path d="M1.61341 8.47537C1.52262 8.33161 1.47723 8.25973 1.45182 8.14886C1.43273 8.06559 1.43273 7.93425 1.45182 7.85097C1.47723 7.74011 1.52262 7.66823 1.61341 7.52447C2.36365 6.33648 4.59682 3.33325 8.00004 3.33325C11.4033 3.33325 13.6364 6.33648 14.3867 7.52447C14.4775 7.66823 14.5228 7.74011 14.5483 7.85097C14.5673 7.93425 14.5673 8.06559 14.5483 8.14886C14.5228 8.25973 14.4775 8.33161 14.3867 8.47537C13.6364 9.66336 11.4033 12.6666 8.00004 12.6666C4.59682 12.6666 2.36365 9.66336 1.61341 8.47537Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M8.00004 9.99992C9.10457 9.99992 9.99997 9.10449 9.99997 7.99992C9.99997 6.89535 9.10457 5.99992 8.00004 5.99992C6.89551 5.99992 6.00011 6.89535 6.00011 7.99992C6.00011 9.10449 6.89551 9.99992 8.00004 9.99992Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_1683_4216">
                                              <rect width="15.9994" height="16" rx="4" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        className="gen-ai-common-popup__icon-btn"
                                        onClick={(e) =>
                                          this.handleRename(
                                            item.notebooklist_id,
                                            item.notebooklist_name
                                          )
                                        }
                                        title="Rename">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g clip-path="url(#clip0_1761_5055)">
                                            <path d="M1.91725 12.0771C1.94788 11.8014 1.96319 11.6636 2.0049 11.5347C2.0419 11.4205 2.09417 11.3117 2.16031 11.2114C2.23485 11.0983 2.33291 11.0003 2.52902 10.8042L11.3329 1.99998C12.0693 1.2636 13.2631 1.2636 13.9995 1.99998C14.7358 2.73636 14.7358 3.93027 13.9995 4.66665L5.19559 13.4708C4.99948 13.6669 4.90142 13.765 4.78838 13.8396C4.68809 13.9057 4.57932 13.958 4.46503 13.995C4.33621 14.0367 4.19838 14.052 3.92273 14.0826L1.66656 14.3333L1.91725 12.0771Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_1761_5055">
                                              <rect width="15.9994" height="16" rx="4" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        className="gen-ai-common-popup__icon-btn"
                                        title="Remove"
                                        onClick={(e) =>
                                          this.handleRemove(
                                            item.notebooklist_id
                                          )
                                        }>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M10.6664 3.99992V3.46659C10.6664 2.71985 10.6664 2.34648 10.521 2.06126C10.3932 1.81038 10.1892 1.60641 9.93837 1.47858C9.65317 1.33325 9.27981 1.33325 8.5331 1.33325H7.46647C6.71976 1.33325 6.34641 1.33325 6.0612 1.47858C5.81033 1.60641 5.60636 1.81038 5.47854 2.06126C5.33322 2.34648 5.33322 2.71985 5.33322 3.46659V3.99992M2 3.99992H13.9996M12.6663 3.99992V11.4666C12.6663 12.5867 12.6663 13.1467 12.4483 13.5746C12.2566 13.9509 11.9506 14.2569 11.5743 14.4486C11.1465 14.6666 10.5865 14.6666 9.4664 14.6666H6.53317C5.41311 14.6666 4.85308 14.6666 4.42527 14.4486C4.04896 14.2569 3.74301 13.9509 3.55127 13.5746C3.33329 13.1467 3.33329 12.5867 3.33329 11.4666V3.99992" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ) : (
                          <div className="gen-ai-common-popup__inner">
                              {" "}
                              You currently do not have any notebooks created.
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ textAlign: "center", padding: "10%" }}>
                        <img
                          src={imsLoader}
                          alt="Loading Data"
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>


              {this.state.isLoaded && (<>
                {this.state.isPin ? (
                  <div className="gen-ai-common-popup__footer">
                    <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline"
                      onClick={() => {
                        this.setState({ showPop: false });
                        this.props.handleClose(false);
                      }}>
                      Cancel
                    </button>
                    <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--primary"
                      onClick={this.onclickProceed}>
                      Save Notebook
                    </button>
                  </div>
                ) : (
                  <div className="gen-ai-common-popup__footer">
                    <button className="gen-ai-common-popup__btn gen-ai-common-popup__btn--outline" onClick={() => {
                      this.setState({ showPop: false });
                      this.props.handleClose(false);
                    }}>
                      Cancel
                    </button>
                  </div>
                )}
              </>)}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessCommonPopup
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <GenAIRenameNotebookPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  nName={this.state.itemtoBeRenamedName}
                  nID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
        </>
      );
    }
  }
}
export default GenAINotebookListPopUp;